import { Tag } from "antd";
import { STATUS_MAP } from "../utils/statusMap";

export default function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || {};

  return (
    <Tag
      style={{
        backgroundColor: s.bg,
        color: s.color,
        borderColor: s.color,
        fontWeight: "bold",
      }}
    >
      {s.label || status}
    </Tag>
  );
}
